export class Vehicle {
    agency?: string;
    isActive?: boolean;
    deviceId?: string;
    vehicleId?: string;
    vehicleNo?: string;
    city?: string;
    lastSeen?: number;
    routeName?: string;
    endStopName: string;
    latitude: number;
    longitude: number;
    startStopName: string;
    timeStamp: number;
    streamId: string;
    routeId: string;
    startTime?: number;
    distance: number;
    alerts: number;

    constructor(id: string, isLive: boolean, timeStamp?: number) {
        this.vehicleId = id;
        this.isActive = isLive;
        this.timeStamp = timeStamp;
    }
}
